<template>
  <div v-if="this.products.length" class="compare-bar">
    <div class="container">
      <div class="compare-bar-selected">
        <div class="compare-bar-inner">
          <ul>
            <li v-for="product in products">
              {{ truncate(product.producttitle) }}
              <a
                href="#"
                @click.prevent="removeItem(product.stockcode)"
              >
                <img src="/cdn/images/site/close-circle.svg" />
              </a>
            </li>
          </ul>
          <div v-if="this.products.length < 2" class="compare-bar-instructions">{{ compare_up_to_4_products }}:</div>
        </div>
      </div>
      <div class="compare-bar-buttons">
        <div class="compare-bar-inner">
          <a href="#" @click.prevent="resetList()" class="btn btn-white-outline-black">{{ cancel }}</a>
          <a
            v-if="this.products.length >= 2"
            href="#"
            @click.prevent="doCompare()"
            class="btn btn-hover btn-primary"
          >{{ compare }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    compareurl: {
      type: String,
      required: true
    },
    compare: {
      type: String,
      required: true,
      default: "Compare"
    },
    cancel: {
      type: String,
      required: true,
      default: "Cancel"
    },
    compare_up_to_4_products: {
      type: String,
      required: true,
      default: "compare between 2 and 4 products"
    }
  },
  data() {
    return {
      products: false,
      nameLength: 15
    };
  },
  mounted() {
    this.products = this.$store.state.compare.list;

    // console.log(this.$refs);
  },
  methods: {
    removeItem(stockcode) {
      this.$store.commit("compare/removeItem", stockcode);
      $("#checkbox" + stockcode).prop("checked", false);
    },
    resetList() {
      for (var i = this.products.length - 1; i >= 0; i--) {
        this.removeItem(this.products[i].stockcode);
      }
    },
    doCompare() {
      let url = this.compareurl + "?products=";

      let stockCodes = this.products.map(function(o) {
        return o.stockcode;
      });

      stockCodes = stockCodes.join(",");
      url = url + stockCodes;
      this.resetList();

      window.location.href = url;
    },
    truncate(s) {
      if (s.length > this.nameLength) {
        return `${s.substring(0, this.nameLength)}...`;
      } else {
        return s;
      }
    }
  },
  computed: {}
};
</script>
